import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { fetchKasanHistory } from '@/apps/latest/features/guidance/apis/kasanHistory'
import { KasanHistoryResponse } from '@/apps/latest/features/guidance/types/kasanHistory'

interface UseKasanHistoryQueryOptions {
  /**
   * リクエストイベントID
   */
  yakurekiId: string | undefined

  /**
   * クエリを有効にするかどうか
   */
  enabled?: boolean
}

/**
 * 加算履歴取得クエリ（TanStack Query）
 *
 * 責務:
 * - 加算履歴データの取得
 * - キャッシュ管理
 *
 * 使用例:
 * ```tsx
 * const { data, isLoading, error, refetch } = useKasanHistoryQuery({
 *   yakurekiId,
 *   enabled: open,
 * })
 * ```
 */
export const useKasanHistoryQuery = (options: UseKasanHistoryQueryOptions) => {
  const { yakurekiId, enabled = true } = options

  return useQuery({
    queryKey: queryKeys.kasanHistory.detail(yakurekiId ?? ''),
    queryFn: async (): Promise<KasanHistoryResponse> => {
      if (!yakurekiId) {
        throw new Error('Request event ID is required')
      }
      const response = await fetchKasanHistory(yakurekiId)
      return response
    },
    enabled: enabled && !!yakurekiId,
    staleTime: 1000 * 60 * 5, // 5分キャッシュ
  })
}
